require('lib/browser_required')('lib/backbone')

const Backbone = require('backbone')
const BackboneStyles = require('lib/backbone_styles')

// insert & remove styles when created and destroyed
function modifyView(ViewClass) {
    return ViewClass.extend({
         
        constructor: function constructor(options = {}) {
            BackboneStyles.addStyles.call(this, this.styles)
            BackboneStyles.addStyles.call(this, options.styles)

            this.once('before:render', BackboneStyles.insertStyles, this)
            this.once('before:destroy', BackboneStyles.removeStyles, this)

            ViewClass.apply(this, arguments)
        },
    })
}
Backbone.View = modifyView(Backbone.View)

// emulate http methods in ajax calls
Backbone.emulateHTTP = true

// start history
if (! Backbone.history) {
    Backbone.history = new Backbone.History()
}
if (! Backbone.History.started) {
    Backbone.history.start({
        pushState: true,
    })
}

// other modifications
require('lib/backbone_serialize')

module.exports = Backbone
